import { Tool } from './base';

export class CarbonBlackCloudInvestigateTool extends Tool {
  public readonly toolName = 'CarbonBlack Cloud - Investigate';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const carbonBlackCloudInvestigateSearchURI =
      'cb/investigate/events/events?query=';
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}${carbonBlackCloudInvestigateSearchURI}${encodedRenderedContent}`;
  }
}
